<template>
    <div>
        <div class="top-category-title">
            <i class="bi bi-award label-icon" :class="icon"></i>
            <span class="label-text">{{ title }}</span>
        </div>
        <div class="row">
			<template v-if="!isLoading">
				<div class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center" v-for="(item, index) in categories" :key="index">
					<div class="card card-body border-0 wrapper-box text-center my-3">
						<div class="box-img">
							<img
								:src="item.image_url"
								:alt="'Landing'"
							/>
						</div>
						<div class="box-title">
							{{ item.title }}
						</div>
						<!-- <div class="box-sold">
							Terjual {{ formatNumber(item.sold) }} pcs
						</div> -->
					</div>
				</div>
			</template>
			<template v-else>
				<div class="col-xl-2 col-lg-3 col-md-4 col-6 d-flex justify-content-center" v-for="(item, index) in dummyCategories" :key="index">
					<div class="card card-body border-0 p-0 wrapper-box text-center my-3 overflow-hidden">
						<div>
							<shimmer
								:width="'300px'"
								height="250px"
							/>
						</div>
						<!-- <div class="mb-4">
							<shimmer
								:width="'300px'"
							/>
						</div> -->
						<!-- <div class="box-sold">
							<shimmer
								:maxWidth="100"
							/>
						</div> -->
					</div>
				</div>
			</template>
        </div>
    </div>
</template>
<script>
import { formatNumber } from '@/lib/helper';
import Shimmer from '@/components/Shimmer.vue';

export default {
	name: 'Featured',
	components: {
		Shimmer,
	},
	props: {
		title: {
			type: String,
			default: 'Top Kategori',
		},
		icon: {
			type: String,
			default: 'bi-award',
		},
		categories: {
			type: Array,
			default: () => [
				{
					title: 'Fashion Pria',
					image_url: 'https://cdn.ostock.id/img/category/fashion_pria.png',
					sold: 5000000,
				},
				{
					title: 'Fashion Wanita',
					image_url: 'https://cdn.ostock.id/img/category/fashion_wanita.png',
					sold: 4000000,
				},
				{
					title: 'Fashion Anak',
					image_url: 'https://cdn.ostock.id/img/category/fashion_anak.png',
					sold: 2300000,
				},
				{
					title: 'Kecantikan',
					image_url: 'https://cdn.ostock.id/img/category/kecantikan.png',
					sold: 2300000,
				},
				{
					title: 'Kesehatan',
					image_url: 'https://cdn.ostock.id/img/category/kesehatan.png',
					sold: 2500000,
				},
				{
					title: 'Handphone & Tablet',
					image_url: 'https://cdn.ostock.id/img/category/handphone_n_tab.png',
					sold: 1900000,
				},
			],
		},
	},
	data() {
		return {
			dummyCategories: new Array(6),
			isLoading: true,
		};
	},
	methods: {
		formatNumber(number) {
			return formatNumber(number, 0, ',', '.');
		},
	},
	created() {
		setTimeout(() => {
			this.isLoading = false;
		}, 2000);
	},
};
</script>
<style lang="scss" scoped>

    .top-category-title {
		// margin-left: 40px;
		margin-bottom: 10px;
		.label-icon {
			font-size: 32px;
			color: #D66956;
			margin-right: 20px;
		}
		.label-text {
			font-style: normal;
			font-weight: 600;
			font-size: 28px;
			color: #4D4D4D;
		}
	}
	.wrapper-box {
		// border: 1px solid #000;
		max-width: 306px;
		// height: 433px;
		// max-height: 433px;
		padding: 16px;
		// background: white;
		border-radius: 16px;
	}
	// .box-img {
	// 	border-radius: 8px;
	// 	object-fit: contain;
	// 	max-width: 266px;
	// 	max-height: 320px;
	// 	margin-bottom: 20px;
	// }
	.box-img {
		border-radius: 8px;
		padding: 0 !important;
		height: auto !important;

		// padding-top: 100%;
		// height: 0;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 20px;

		img {
			position: relative !important;
			// max-height: none!important;

			width: 100%;
			flex-shrink: 0;
			min-width: 100%;
			min-height: 100%;
			max-width: 100%;
			// max-height: 100%;
			// max-height: 265px;
			object-fit: cover;
			// position: absolute;
			top: 0;
			bottom: 0;
			margin: auto;
			transition: 0.3s all cubic-bezier(0.45, 0.05, 0.55, 0.95);
			height: 200px;
		}
	}
	.box-title {
		font-weight: 700;
		font-size: 16px;
		color: #1B1C1EDE;
	}
	.box-sold {
		margin-top: 5px;
		font-weight: 500;
		font-size: 16px;
		color: #D66956;
	}

	// .col-md {
	// 	padding-right: 5px !important;
	// 	padding-left: 5px !important;
	// }
</style>
